import React from 'react';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import { Box, FormControlLabel, Switch, Typography, Tooltip, IconButton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { FormField } from '@shared/components/FormField/FormField';

interface OfferFlagsProps {
  control: Control<any>;
  errors: FieldErrors;
}

export const OfferFlags: React.FC<OfferFlagsProps> = ({ control }) => {
  return (
    <Box>
      <FormField label="Offer Flags" />
      <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
        <Controller
          name="starter_offer"
          control={control}
          render={({ field }) => (
            <FormControlLabel
              control={
                <Switch
                  sx={{ marginRight: 0 }}
                  checked={field.value}
                  onChange={field.onChange}
                  data-testid="starter-offer-switch"
                />
              }
              label={
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Typography variant="body2">Starter Offer</Typography>
                  <Tooltip title="Mark as a starter offer for new users" arrow>
                    <IconButton size="small" sx={{ p: 0 }}>
                      <InfoOutlinedIcon sx={{ fontSize: 16 }} />
                    </IconButton>
                  </Tooltip>
                </Box>
              }
            />
          )}
        />
        <Controller
          name="is_featured"
          control={control}
          render={({ field }) => (
            <FormControlLabel
              control={
                <Switch
                  sx={{ marginRight: 0 }}
                  checked={field.value}
                  onChange={field.onChange}
                  data-testid="featured-switch"
                />
              }
              label={
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Typography variant="body2">Featured</Typography>
                  <Tooltip
                    title="Display at top of shop with special teaser image. Not affected by targeted marketing."
                    arrow
                  >
                    <IconButton size="small" sx={{ p: 0 }}>
                      <InfoOutlinedIcon sx={{ fontSize: 16 }} />
                    </IconButton>
                  </Tooltip>
                </Box>
              }
            />
          )}
        />
        <Controller
          name="is_test_offer"
          control={control}
          render={({ field }) => (
            <FormControlLabel
              control={
                <Switch
                  sx={{ marginRight: 0 }}
                  checked={field.value}
                  onChange={field.onChange}
                  data-testid="test-offer-switch"
                />
              }
              label={
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Typography variant="body2">Test Offer</Typography>
                  <Tooltip title="Mark as a test offer for internal testing" arrow>
                    <IconButton size="small" sx={{ p: 0 }}>
                      <InfoOutlinedIcon sx={{ fontSize: 16 }} />
                    </IconButton>
                  </Tooltip>
                </Box>
              }
            />
          )}
        />
        <Controller
          name="is_shop_default"
          control={control}
          render={({ field }) => (
            <FormControlLabel
              control={
                <Switch
                  sx={{ marginRight: 0 }}
                  checked={field.value}
                  onChange={field.onChange}
                  data-testid="shop-default-switch"
                />
              }
              label={
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Typography variant="body2">Default Shop Offer</Typography>
                  <Tooltip title="Pre-select this offer in the shop page" arrow>
                    <IconButton size="small" sx={{ p: 0 }}>
                      <InfoOutlinedIcon sx={{ fontSize: 16 }} />
                    </IconButton>
                  </Tooltip>
                </Box>
              }
            />
          )}
        />
      </Box>
    </Box>
  );
};
